/**
* Version 0.100
* 
* Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
* Copyright 2016 - 2025.
* 
* !Changelog

* 	17-10-2018
* 	- [BORN] This class is born. Hooray!
* 
* !Usage
* 
*   - 
* 	
* !Wishlist
* 
* 	// none
* 	
*/

var specific_reviews = {};

(function () {

	// DOCUMENT READY  *****************************************************************
	// DOCUMENT READY *****************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************

	this.onready = function (

	) {

		/**
		 * Trigger: Review Swiper
		 */
		var _review_swiper = new Swiper('.js-review-swiper', {

			/**
			 * Centered slides
			 */
			centeredSlides: true,
			slidesPerView: 1,
			autoHeight: true,

			loop: true,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			// If we need pagination
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},

			/**
			 * Breakpoints
			 */
			breakpoints: {
				768: {
					slidesPerView: 2
				}
			}

		});


	};

	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************

	// none yet

}).apply(specific_reviews);